// Module
var code = "<md-contact-chips ng-model=\"$ctrl.selectedItems\" md-contacts=\"$ctrl.onSearch($query)\" md-contact-name=\"name\" md-contact-image=\"image\" md-require-match=\"true\" md-highlight-flags=\"i\" ng-change=\"$ctrl.onSelectItem()\" placeholder=\"{{'Search Drivers' | translate}}\"> </md-contact-chips> ";
// Exports
export default code;